<template>
  <div class="" style="background-color: #e5e5e5" >
    <div class="row no-gutters row-bordered row-border-light">
      <div class="col-lg-4 col-12 pt-0 px-1 py-3" >
        <charts-homepage></charts-homepage>

      </div>
      <div class="col-lg-8 col-12 px-2 py-3">

        <div class="border border-dark">
          <div class="p-1" style="height:85vh; background-color: white">

            <l-map  :zoom="zoom" :center="center">
              <l-tile-layer :url="url"></l-tile-layer>
              <l-control  class="example-custom-control">
                <b-spinner  v-if="tst" variant="success" type="grow" label="Spinning"></b-spinner>
                <div style="background-color: white; color: white" class="rounded">
                  <div class="p-1">
                    <p class="bold text-dark font-weight-bold text-center" style="font-size: 14px">Mosquitoes:</p>
                    <div class="p-1 rounded" style="background-color: #0a6715">
                      <b-form-checkbox v-model="visible_culex">Culex</b-form-checkbox>
                    </div>
                  </div>
                  <div class="p-1">
                    <div class="p-1 rounded" style="background-color: #e9820c">
                      <b-form-checkbox v-model="visible_aedes">Aedes</b-form-checkbox>
                    </div>
                  </div>
                  <div class="p-1">
                    <div class="p-1 rounded" style="background-color: #fc0404">
                      <b-form-checkbox v-model="visible_anopheles">Anopheles</b-form-checkbox>
                    </div>
                  </div>
                  <div class="p-1 d-flex" style="color: #050505">
                    <b-icon class="mt-2" icon="flag-fill" scale="1.5" >
                    </b-icon>
                    <p class="bold px-2 text-dark font-weight-bold text-center" style="font-size: 14px">Periodical Traps</p>
                  </div>
                </div>
                <b-form-select  v-model="selectedTrapsDataYear" class="mb-3" @change="ChangeTrapsDataYear">
                    <!-- This slot appears above the options from 'options' prop -->
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Select Year --</b-form-select-option>
                    </template>

                    <!-- These options will appear after the ones from 'options' prop -->
                    <b-form-select-option v-for="year in years_traps_data" :key="year.extractYear+'year'"  :value="year.extractYear" >{{year.extractYear}}</b-form-select-option>
                 </b-form-select>
              </l-control>
              <l-marker
                v-for="col in data_Loc" :lat-lng="[col.longitude, col.latitude]"
                :key="col.id"
                :icon="icons(col)"
                :visible="isVisible(col.mosquito_type)" @click="login"
              />
              <l-polygon
                v-for="country in polygon.latlngs"
                :key="country.id"
                :lat-lngs="country"
              />
            </l-map>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 p-2 d-flex justify-content-center align-items-center bg-light">
     
      <img src="img/eshape.png"  class="" style="width:3%">
      <img src="img/europe.jpg"  style="margin-left: 10px;width:3%">
      
      <a href="https://e-shape.eu/" class="px-3 text-dark" target="_blank">The e-shape project has received funding from the European Union’s Horizon 2020 research and innovation programme under grant agreement 820852</a>
                        
    </div>
  </div>
</template>

<script>
import axios from '../../axios-auth'
import {LMap, LTileLayer, LCircleMarker,LGeoJson,LMarker,LIcon, LControl, LPolygon  } from 'vue2-leaflet';
import { icon } from "leaflet";
import VueHighcharts from 'vue2-highcharts'
import ChartsHomepage from '../ChartsHomePage.vue'

export default {
  components: {
    ChartsHomepage,
    LMap,
    LTileLayer,
    LCircleMarker,
    VueHighcharts,
    //LGeoJson,
    LMarker,
    LIcon,
    LControl,
    LPolygon
  },
  mounted() {

  },
  data () {
    return {
      selectedTrapsDataYear:null,
      years_traps_data:null,
      tst: true,
      polygon: {
        latlngs: [],
      },
      show: true,
      visible_culex: true,
      visible_aedes: true,
      visible_anopheles: true,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 3,
      center: [40.6659, 22.1937],
      data_Loc:{},

      icon: icon({
        iconUrl: "/squat-marker-green.png",
        iconSize: [20, 22],

      }),
     
    };
  },
  async created () {
    //const response = await fetch('https://rawgit.com/gregoiredavid/france-geojson/master/regions/pays-de-la-loire/communes-pays-de-la-loire.geojson');
    //this.geojson = await response.json();
    /*const res = await axios.get('http://127.0.0.1:8000/entomologicalData/anopheles/v2/', {

      auth: {
        username: 'kontoes@noa.gr',
        password: 'Xjdb;P.5_V'
      }
    });
    console.log(res)*/
    var country_geom=null
   
    country_geom=await axios.get('entomologicalData/country/',{params:{group:'[{"name":"view_all"}]'}})
    

    this.country=country_geom.data
    console.log(this.country)
    // this.polygon.latlngs=JSON.parse(country_geom.data.json).coordinates
    for(var i=0; i<country_geom.data.length; i++) {


      //var result = country_geom.data[i].geom.split(';')
      //var geojson_pgons = Terraformer.WKT.parse(result[1])
      // console.log(geojson_pgons)

      const latlgn = L.geoJSON(JSON.parse(this.country[i].json))
      const latlgn_id = latlgn._leaflet_id - 1
      // console.log(latlgn)
      const latlgn_data = latlgn._layers[latlgn_id]._latlngs

      this.polygon.latlngs[i] = latlgn_data
    }
    //console.log(this.polygon)

    var data=null
    
    var years_traps_data_all=await axios.get('distinct-years-entomological-data/')
    this.years_traps_data=years_traps_data_all.data
    this.selectedTrapsDataYear=this.years_traps_data[0].extractYear
    data=await axios.get('entomologicalData/markers/',{params:{year:this.selectedTrapsDataYear,group:'[{"name":"view_all"}]'}})
  

    this.data_Loc=data.data
    console.log(this.data_Loc)
    this.tst=false
  },

  methods:{
    async ChangeTrapsDataYear(){
    
    var data=await axios.get('entomologicalData/markers/',{params:{year:this.selectedTrapsDataYear,group:'[{"name":"view_all"}]'}})
  

    this.data_Loc=data.data
    },
    icons(item){
      if(item.mosquito_type==='culex' ){
        if(item.trapscount>5) {
          // return this.circle.color='green'
          return icon({
            iconUrl: "/img/icon-green.png",
            iconSize: [40, 40],
          })
        }
        else{
          return icon({
            iconUrl: "/img/icon-green-info.png",
            iconSize: [20, 20],
          })
        }
      }

      if(item.mosquito_type==='aedes'){
        // return this.circle.color='orange'
        return icon({
          iconUrl: "/img/icon-orange.png",
          iconSize: [40, 40],
        })
      }
      if(item.mosquito_type==='anopheles'){
        if(item.trapscount>5) {
          // return this.circle.color='red'
          return icon({
            iconUrl: "/img/icon-red.png",
            iconSize: [35, 35],
          })
        }
        else {
          return icon({
            iconUrl: "/img/icon-red-info.png",
            iconSize: [20, 20],
          })
        }
      }

    },
    isVisible(item){
      if(item==='culex'){
        return this.visible_culex
      }
      if(item==='aedes'){
        return this.visible_aedes
      }
      if(item==='anopheles'){
        return this.visible_anopheles
      }

    },
    login(){
     // console.log('here')
      alert('You must login to view this data');
    }

  },
}
</script>

<style>
hr {
  margin-top: 0rem;
  margin-bottom: 0rem;
  width: 96%;
  border-top: 1px solid rgba(2, 2, 2, 1);
}
p{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.leaflet-container {
  font: 15px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
}


</style>
